var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "slider-container as-flex flex-vertical main-start corss-start",
    },
    [
      _c("el-slider", {
        staticClass: "slider",
        attrs: {
          max:
            _vm.type === "box"
              ? _vm.boxArray.length - 1
              : _vm.yearArray.length - 1,
          step: 1,
          "format-tooltip": _vm.generateTooltips,
          range: "",
          "show-stops": "",
        },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "current-value as-flex main-end cross-center" },
        [_vm._v(_vm._s(_vm.label))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "function-bar as-flex main-end cross-center" }, [
        _c("div", { staticClass: "confirm-btn", on: { click: _vm.confirm } }, [
          _vm._v("确定"),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }